import { z } from 'zod';

import { zodInvoiceAssigneeSchema } from '../useQueryInvoiceDetail/validations';

import {
  INVOICE_V2_RESULT_STATUS,
  INVOICE_V2_SOURCE,
  INVOICE_V2_STATUS,
} from './constants';

const zodDateSchema = z.iso.date().nullish();
const zodDateTimeSchema = z.iso.datetime({ offset: true }).nullish();
const zodDecimalSchema = z.string().nullish();

const zodInvoiceV2StatusSchema = z.enum(INVOICE_V2_STATUS);
const zodInvoiceV2ResultStatusSchema = z.enum(INVOICE_V2_RESULT_STATUS);
const zodInvoiceV2SourceSchema = z.enum(INVOICE_V2_SOURCE);

export const zodInvoicesV2QueryParamsSchema = z.object({
  accountingReferenceId: z.array(z.uuid()).optional(),
  assigneeId: z.array(z.uuid()).optional(),
  buyerCompanyId: z.uuid().optional(),
  invoiceDateFrom: z.iso.date().optional(),
  invoiceDateTo: z.iso.date().optional(),
  issuerCompanyId: z.uuid().optional(),
  limit: z.number().int().min(1).max(500).prefault(50),
  offset: z.number().int().min(0).prefault(0),
  orderBy: z
    .enum([
      'receipt_date',
      'invoice_date',
      'invoice_number',
      'gross_amount',
      'due_date',
      'net_amount',
      'tax_amount',
      'result_status',
      'source',
      'issuer_name',
      'buyer_name',
      'skonto_due_date',
    ])
    .prefault('receipt_date'),
  receiptDateFrom: z.iso.date().optional(),
  receiptDateTo: z.iso.date().optional(),
  resultStatus: zodInvoiceV2ResultStatusSchema.optional(),
  searchString: z.string().trim().optional(),
  siteId: z.array(z.uuid()).optional(),
  sortOrder: z.enum(['asc', 'desc']).prefault('desc'),
  source: zodInvoiceV2SourceSchema.optional(),
  timezone: z.string().optional(),
  unassigned: z.boolean().optional(),
});

const zodInvoiceV2PartySchema = z
  .object({
    companyId: z.uuid().nullish(),
    name: z.string().nullish(),
  })
  .nullish();

export const zodInvoiceV2SummarySchema = z.object({
  assignees: z.array(zodInvoiceAssigneeSchema),
  buyer: zodInvoiceV2PartySchema,
  currency: z.string().nullish(),
  dueDate: zodDateSchema,
  grossAmount: zodDecimalSchema,
  id: z.uuid(),
  invoiceDate: zodDateSchema,
  invoiceNumber: z.string().nullish(),
  issuer: zodInvoiceV2PartySchema,
  netAmount: zodDecimalSchema,
  ownerCompanyAccountId: z.uuid(),
  ownerCompanyId: z.uuid().nullish(),
  receiptDate: zodDateTimeSchema,
  resultStatus: zodInvoiceV2ResultStatusSchema,
  skontoDueDate: zodDateSchema,
  source: zodInvoiceV2SourceSchema,
  status: zodInvoiceV2StatusSchema,
  taxAmount: zodDecimalSchema,
});

export const zodInvoicesV2ResponseSchema = z.object({
  data: z.array(zodInvoiceV2SummarySchema),
  hasNextPage: z.boolean(),
  paginatedCount: z.number().int().nonnegative(),
  totalCount: z.number().int().nonnegative().nullable(),
});
